export type AuthenticationMethod =
  | 'cta-token'
  | 'password'
  | 'cta-oidc'
  | 'cta-saml'
  | 'cta-okta-redirect';
